import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-changeboarding.title',
		defaultMessage: 'Improved navigation',
		description: 'Title. Show in spotlight.',
	},
	description: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-changeboarding.description',
		defaultMessage:
			'Quickly find your project’s settings with the help of clear labels and the grouping of related items.',
		description: 'Description. Show in spotlight.',
	},
	readMoreLink: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-changeboarding.read-more-link',
		defaultMessage: 'Read more about this change',
		description: 'Read more link, part of the spotlight description',
	},
	ok: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-changeboarding.ok',
		defaultMessage: 'OK',
		description: 'Spotlight action, ends the spotlight nudge.',
	},
});
